import _ from 'lodash';

/**
 * Returns whether a LC (Licencia de Conducir) is valid.
 */
function isLC (value) {
    return !_.isString(value) || value.length < 6 || value.length > 7;
}

export default isLC;
